import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberInfoSettings defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberInfoSettingsService } from 'services/memberInfoSettings';
 *
 * // create service instance and send/cancel request
 * const memberInfoSettingsService = new MemberInfoSettingsService();
 * const result = await memberInfoSettingsService.fetchData( '<user-id>' ); // fetch data
 * memberInfoSettingsService.cancel(); // cancel an active request
 */
export class MemberInfoSettingsService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, requestPayload = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: requestPayload,
            } );

            // extract component data
            const visibility = get( response, 'body.component.visibility', {} );
            const tabs = get( response, 'body.component.structure.tabs', [] );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    tabs: getVisibleItems( tabs, visibility ),
                },
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
